export default __webpack_public_path__ + "static/media/logo.5bf30723.png";